export const getPromoProductBaseId = row => {
  const rawId =
    row?.product_base_id ?? row?.produto_base_id ?? row?.promo?.product_base_id;
  const productBaseId = Number(rawId);

  return Number.isInteger(productBaseId) && productBaseId > 0
    ? productBaseId
    : null;
};

export const buildPromoBulkItems = editedPromo => {
  const items = [];
  const invalidKeys = [];

  Object.entries(editedPromo).forEach(([productBaseId, isActive]) => {
    const parsedProductBaseId = Number(productBaseId);

    if (!Number.isInteger(parsedProductBaseId) || parsedProductBaseId <= 0) {
      invalidKeys.push(productBaseId);
      return;
    }

    items.push({
      product_base_id: parsedProductBaseId,
      is_active: Boolean(isActive)
    });
  });

  return { items, invalidKeys };
};

export const buildApplyPriceItem = (row, editedAmeixaPrices, editedPromo) => {
  const item =
    editedAmeixaPrices[row.id] !== undefined
      ? {
          productBaseId: row.product_base_id,
          target_ameixa_price: editedAmeixaPrices[row.id]
        }
      : {
          productBaseId: row.product_base_id,
          price: row.preco_final
        };

  const promoProductBaseId = getPromoProductBaseId(row);
  if (
    promoProductBaseId != null &&
    editedPromo[promoProductBaseId] !== undefined
  ) {
    item.isPromotionActive = Boolean(editedPromo[promoProductBaseId]);
  }

  return item;
};

export const clearAppliedPromoEdits = (
  editedPromo,
  pendingResolved,
  idsToConfirm
) => {
  const next = { ...editedPromo };

  idsToConfirm.forEach(id => {
    const row = pendingResolved.find(r => r.id === id);
    if (!row) return;
    const promoProductBaseId = getPromoProductBaseId(row);
    if (promoProductBaseId != null) {
      delete next[promoProductBaseId];
    }
  });

  return next;
};
